module DealerwareWebComponents {

    "use strict";



    export class AgreementSelectionsController {

        public static $inject : string[ ] = [ '$scope', '$timeout', '$state' ];

        private selectionBoxes                  : any;
        private originalSelectionBoxes          : any[];

        private activeSelectionId               : string;
        private selectedPage                    : any;

        private selectionTargetScopeInsertions  : any;

        private allowedSelectionBoxIds : any = {
            'signature' : [ 'set-signature' ],
            'date'      : [ 'set-date' ],
            'none'      : [ ]
        };

        // This is a dummy to prevent a linting error.
        //
        private agreementSelections: any;

        constructor(
            private $scope: IDefineSignatureDateScope,
            private $timeout: ng.ITimeoutService,
            private $state: any
        ) {

            var that = this;

            that.initializePageAndSelections();
            that.createSignatureLocationInterface();
        }

        public getSelectedPageUrl () : any {
            return ( ) => {
                return (this.selectedPage || { }).thumbnailUrl;
            };
        }

        private createSignatureLocationInterface ( ) : void {

            this.selectionBoxes = {
                'set-signature' : {
                    id          : 'set-signature',
                    content     : { template: 'sampleSignature', element: null }
                },
                'set-date'      : {
                    id          : 'set-date',
                }
            };

            this.originalSelectionBoxes = angular.copy(this.selectionBoxes);

            this.activeSelectionId = 'set-signature';
        };

        private initializePageAndSelections () : void {

            var that = this;

            // (Somewhat) cleverly get the current pdf page into the image box target's src attribute.
            //
            this.selectionTargetScopeInsertions = {
                getSelectedPageUrl : this.getSelectedPageUrl(),
                getPageImageStyle  : this.$scope.getPageImageStyle.call(this)
            };

            this.$scope.$watch( ( coords: any ) => {
                return that.$scope.selectedPage;
            }, ( selectedPage: any, oldSelectedPage: any ) => {

                if (selectedPage === undefined) {
                    return;
                }

                that.selectedPage = selectedPage;
                that.resolveBoxCreationOrDeletion('set-signature', oldSelectedPage);
            });
        }

        // Depending on what data changes to fire the selectedPage watcher above, this it might be necessary to
        // create a box or boxes from previously saved (to the database) data, or deletion of already drawn boxes
        // (from save restoration or user input) when e.g. the selected page changes.
        //
        private resolveBoxCreationOrDeletion ( stepAlias: string, oldSelectedPage?: any ) : void {

            var that = this;

            var stepPrefix = stepAlias === 'set-signature' ? 'signature' : 'date';

            // New page selected.  Blow away previous signature and date.
            //
            if (oldSelectedPage && oldSelectedPage.selected === false) {

                if (this.selectionBoxes['set-signature'].element) {
                    this.clearSetSignature();
                }

                if (this.selectionBoxes['set-date'].element) {
                    this.clearSetDate();
                    this.activeSelectionId = 'set-signature';
                }
                return;
            }

            if ( this.selectedPage[stepPrefix + 'X'] === undefined
                 || this.selectedPage[stepPrefix + 'X'] === 0
               ) {
                return;
            }

            var box = this.selectionBoxes[stepAlias];

            box['startX'] = this.selectedPage[stepPrefix + 'X'];
            box['startY'] = this.selectedPage[stepPrefix + 'Y'];
            box['width']  = this.selectedPage[stepPrefix + 'Width'];
            box['height'] = this.selectedPage[stepPrefix + 'Height'];

            // The .trigger is running outside of angular.
            //
            this
                .$timeout( ( ) => {

                    // Sometimes it's just not worth trying to abstract user-event-driven code out so
                    // that it can be called programatically independent of DOM events, especially
                    // when it's easy to "pass" custom event data containing your expando event properties.
                    // And that's when, I assert, faking events is ok.
                    //
                    // Fire mousedown then mouseup starts and finishes creating a SelectionBox, and
                    // giving offsetX and offsetY makes it appear in the right place.
                    //
                    angular.extend(box, {
                        offsetX:  that.selectedPage[stepPrefix + 'X'],
                        offsetY:  that.selectedPage[stepPrefix + 'Y']
                    });

                    angular.element('#selected-page-image').trigger('mousedown', box);
                    angular.element('#selected-page-image').trigger('mouseup');
                }, 250)
                .then( ( ) => {

                    // ...and this one needs that mouseup event to finish before sizing the signature mockup to
                    // the full size of the box.  But I think putting a sliver of a delay in here will make
                    // sure that there will be success.
                    //
                    that.$timeout( ( ) => {
                        if (that.$scope.onSelectionBoxSizing) {
                            that.$scope.onSelectionBoxSizing (box);
                        }
                        else {
                            that.onSelectionBoxSizing (box);
                        }
                    }, 250)
                        .then( ( ) => {
                            if (stepAlias !== 'set-date') {
                                that.activeSelectionId = 'set-date';
                                that.resolveBoxCreationOrDeletion('set-date');
                            }
                        });
                });
        }

        public clearSetSignature ( ) : void {
            this.activeSelectionId = 'set-signature';
            this.clearSelectionBoxAndCoordinateData();
        }

        public clearSetDate ( ) : void {
            this.activeSelectionId = 'set-date';
            this.clearSelectionBoxAndCoordinateData();
        }

        public clearSelectionBoxAndCoordinateData ( ) : void {

            var id = this.activeSelectionId;

            this.selectionBoxes[id].delete();
            this.selectionBoxes[id] = angular.copy(
                (<any>this.originalSelectionBoxes)[id]
            );

            // If called due to a page reselection, instead of a clear button click,
            // the newly selected page will not have any coordinate data set, (in the
            // agreement.pages data structure) so this doesn't do anything.
            //
            this.$scope.deleteSignatureDateCoordinates({
                stepName: this.activeSelectionId
            });
        }

        public isPageSelected ( ) : boolean {
            return this.$scope.isPageSelected();
        }

        public isSignatureDefined ( ) : any {
            return this.$scope.isSignatureDefined();
        }

        public isDateDefined ( ) : any {
            return this.$scope.isDateDefined();
        }

        public goToPage ( stepName: string ) : void {
            this.$scope.goToPage.call(this.$scope.parentController || this,
                { $state: this.$state, stepName: stepName }
            );
        }

        public setSignatureDateCoordinates ( box: any ) : void {

            this.$scope.setSignatureDateCoordinates( {
                stepName        : box.id,
                coordinateData  : box
            } );
        }

        public checkThisStep ( stepName: any ) : boolean {
            return this.$scope.checkThisStep( { stepName: stepName } );
        }

        // Box creation callback set the coordinates of the just-created box in the agreement
        // object.
        //
        public onSelectionBoxCreated (box: any) : any {

            // It isn't so great to rely on what the controller including AgreementSelectionsController
            // (via $controller, e.g. DefineSignatureDateController) calls this controller as one of its properties
            // and then hardwiring it here.
            //
            this.agreementSelections.activeSelectionId = box.id === 'set-date' ? 'set-signature' : 'set-date';
            this.setSignatureDateCoordinates (box);
        }

        // Box sizing callback changes the size of the element inside the box as the box
        // itself changes dimensions, i.e. the signature or date mockup images.
        //
        public onSelectionBoxSizing (box: any) : void {

            if (box.content) {
                box.content.element.css('width', box.width);
                box.content.element.css('height', box.height);
            }
        }

        public onSelectionBoxMoved (box: any) : void {
            this.setSignatureDateCoordinates (box);
        }
    }

    getDealerwareWebComponentsModule().controller(
        'AgreementSelectionsController',
        AgreementSelectionsController
    );

}
